// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../../../common/modules/user/services/SessionService';
import { UserService } from '../../../common/modules/user/services/UserService';
// Models
import { User } from '../../../common/modules/user/models/User';
import { Credential } from '../../../common/modules/user/models/Credential';

@Component({
    selector: 'user-login',
    template: require('./LoginComponent.html'),
    styles: [require('./LoginComponent.sass')],
})

export class LoginComponent implements OnInit {
    credential:     Credential;
    message:        string;
    messageType:    string;
    redirectUrl:    string;
    formSubmitted: boolean = false;
    
    constructor(
        private sessionService: SessionService,
        private userService: UserService,
        private router: Router
    ) {}

    ngOnInit() {
        this.redirectUrl = '/booking/students';
        this.credential = new Credential('hol-parent', '', '');
         // Use Session Service to get session and check if user had already logged in.
        this.getSession();
    };

    onSubmit() {
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSession(this.credential);
    }

    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.redirect(this.redirectUrl);
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    /**
     * Post Session to API service to create new session.
     * Update User Data on local storage and redirect to desired URL
     * if request responses session data.
     * @param {Credential} - user credential input
     * @return none
     */
    private postSession(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    // Set user session data
                    this.userService.setUserSessionData(user);

                    // Fire user session data changed event
                    this.userService.userDataChanged(user);

                    // Redirect to desired URL
                    this.redirect(this.redirectUrl);
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}



// WEBPACK FOOTER //
// ./src/holiday/parent/login/LoginComponent.ts